// Shared utilities for form handling

/**
 * Returns true when the provided rich text/HTML content is effectively empty.
 * Strips tags and &nbsp;, then trims the remaining text.
 */
export const isRichTextEmpty = (html?: unknown): boolean => {
  if (typeof html !== "string") return true;
  const stripped = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();
  return stripped === "";
};
